import { mapMutations } from "vuex";
import routerNames from "@/router/constants";
export default {
  methods: {
    ...mapMutations({
      setData: "SET_DATA",
      resetOldCars: "moduleOldCars/RESET_CARS",
    }),
    resetStoreData(route) {
      if (route.link === routerNames.oldCars) {
        this.resetOldCars();
      }
      if (route.link === routerNames.newCars) {
        this.setData({
          field: "moduleNewCars.page",
          data: null,
        });

        this.setData({
          field: "scrollPositionPageDealers",
          data: 0,
        });
      }
    },
    routerPush(route) {
      this.$router.push(route.link)
    }
  }
}